import React from 'react';
import { Helmet } from 'react-helmet';
import './Home.css';
import Hero from './Hero';
import Audience from './Audience';
import Tools from './Tools';
import Features from './Features';
import TestIt from './TestIt';
import FAQ from './FAQ';
import Interested from '../common/components/interested/Interested';
import Testimonials from './Testimonials';

function Home() {

  return (
    <React.Fragment>
      <Helmet>
        <title>Sera</title>
        <meta name="title" content="Get Help Paying Off Debt, Growing Your Assets, and Generating Passive Income - Sera. Financial Freedom. Simplified"/>
        <meta name="description" content="A financial wellness platform that helps you eliminate debt, grow assets and generate passive income to achieve financial freedom, as quickly and simply as possible"/>
        <meta name="keywords" content="credit card debt, financial freedom, debt reduction, debt elimination, investing, debt free, asset growth, asset acceleration, passive income, financial wellness, financial health, retire early, investments"/>
        <meta name="robots" content="index, follow"/>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
        <meta name="language" content="English"/>
        <meta name="revisit-after" content="1 days"/>
        <meta name="author" content="Sera, LLC"/>
      </Helmet>
      <div className='home'>
        <Hero />
        <Audience />
        <Tools />
        {/*
        <Features />
        <TestIt />
        */}
        <Testimonials />
        <FAQ />
        <Interested showGraphic={true} showContactUs={true} />
      </div>
    </React.Fragment>
  );
}

export default Home;